let vibe_cake_masters_buy_full_course_cta = ( function ( $ ) {

	let loading = require( './loading' );

	let _init = function() {
		let $cards = $( '.targeted-landing-page-buy-full-course-cta' ).not( '.setup-card' );

		if ( $cards.length > 0 ) {

			$cards.each( (index, item) => {
				_setup_card( $( item ) );
			} );
		}
	}

	let _setup_card = function( $card ) {
		let $full_input    = $card.find( 'input[value="full"]' ),
			$partial_input = $card.find( 'input[value="installments"]' ),
			$add_button    = $card.find( '.add-to-cart-dropdown .course-add-selection-to-cart' );

		$card.find( 'a.buy-full-button' ).on( 'click', ( e ) => {
			e.preventDefault();

			$card.loading();

			$full_input.prop( 'checked', true );
			$partial_input.prop( 'checked', false );

			$full_input.trigger( 'change' );

			$add_button.trigger( 'click' );

			$( document.body ).on( 'masters-cart-course_added_to_cart_body masters-cart-course_add_to_cart_error_body', () => {
				$card.loaded();
			} );
		} );

		$card.find( 'a.buy-partial-button ' ).on( 'click', ( e ) => {
			e.preventDefault();

			$card.loading();

			$full_input.prop( 'checked', false );
			$partial_input.prop( 'checked', true );

			$full_input.trigger( 'change' );

			$add_button.trigger( 'click' );

			$( document.body ).on( 'masters-cart-course_added_to_cart_body masters-cart-course_add_to_cart_error_body', () => {
				$card.loaded();
			} );
		} );


		$card.addClass( 'setup-add-to-cart' );
	}

	$( document ).ready( _init );

} )( jQuery );

module.exports = vibe_cake_masters_buy_full_course_cta;